import React from 'react'

import {Box, Typography} from "@mui/material"


export default function timestampExportColumn() {

    return {
        name: 'timestampExport',
        label: 'Export Date',
        options: {
            customBodyRowRenderLite: value => <Box
                sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Typography variant="body1">{value}</Typography>
            </Box>
        }
    }
}